import { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { lazyGetLotteryPrizeList } from 'client/redux/modules/lotteryPrizes';
import { lazyGetMGMtLotteryPrizeList } from 'client/redux/modules/mgmReferral';

export default function useLotteryPrizeDataManage({ onError = () => {} } = {}) {
    const dispatch = useDispatch();
    const lotteryPrizes = useSelector(s => s.lotteryPrizes);
    const { lotteryPrizes: mgmLotteryPrizes = {} } = useSelector(s => s.mgmReferral);
    const currentLotteryPrizes = { ...lotteryPrizes, ...mgmLotteryPrizes };
    const [inited, setInited] = useState({});
    const fetchedRef = useRef({});

    function handleLoad(lotteryUUID, isMgm = false) {
        if (lotteryUUID && !fetchedRef.current[lotteryUUID]) {
            if (currentLotteryPrizes[lotteryUUID] !== undefined) {
                fetchedRef.current[lotteryUUID] = true;
                setInited(c => ({ ...c, [lotteryUUID]: true }));
            } else if (!fetchedRef.current[lotteryUUID]) {
                fetchedRef.current[lotteryUUID] = true;
                getLotteryPrizesData(lotteryUUID, isMgm);
            }
        }
    }
    async function getLotteryPrizesData(lotteryUUID, isMgm) {
        try {
            if (isMgm) {
                await dispatch(lazyGetMGMtLotteryPrizeList({ lotteryUUID }));
            } else {
                await dispatch(lazyGetLotteryPrizeList({ lotteryUUID }));
            }
            setInited(c => ({ ...c, [lotteryUUID]: true }));
        } catch (err) {
            onError({
                err
            });
        }
    }

    return {
        load: handleLoad,
        isLotteryHasLoadPrizeData: lotteryUUID => Boolean(inited[lotteryUUID])
    };
}
